// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__azhX6","signatureBlock":"Footer_signatureBlock__1LJUU","signature":"Footer_signature__1yi6U"};